import { render, staticRenderFns } from "./DevamEdenGorevList.vue?vue&type=template&id=6571258b&scoped=true"
import script from "./DevamEdenGorevList.vue?vue&type=script&lang=ts"
export * from "./DevamEdenGorevList.vue?vue&type=script&lang=ts"
import style0 from "./DevamEdenGorevList.vue?vue&type=style&index=0&id=6571258b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571258b",
  null
  
)

export default component.exports